/**
 * Adaptive configuration based on browser/hardware capabilities.
 * Dynamically adjusts upload concurrency, chunk sizes, and worker counts
 * based on available CPU cores and device memory.
 */

interface AdaptiveConfig {
  concurrentUploads: number;
  chunkSize: number;
  hashChunkSize: number;
}

export function getAdaptiveConfig(): AdaptiveConfig {
  const cores = navigator.hardwareConcurrency || 4;
  const memoryGB = (navigator as any).deviceMemory || 4;

  return {
    // Concurrent uploads: scale with CPU cores, min 3, max 8
    concurrentUploads: Math.max(3, Math.min(cores, 8)),

    // Upload chunk size: low memory (<=2GB) uses 50MB, otherwise 100MB
    chunkSize: memoryGB <= 2 ? 50 * 1024 * 1024 : 100 * 1024 * 1024,

    // Hash chunk size: low memory uses 32MB, otherwise 64MB
    hashChunkSize: memoryGB <= 2 ? 32 * 1024 * 1024 : 64 * 1024 * 1024,
  };
}
